<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="550px"
            content-class="v-dialog--large"
        >
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("price") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-flex xs12>
                            <v-layout wrap>
                                <v-flex xs6>
                                    <v-text-field
                                        v-model="dMin"
                                        :label="`${$t('minDmm')} *`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field
                                        v-model="price"
                                        :label="`${$t('price')} *`"
                                        mr-2
                                        required>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-container>
                    <small>{{ $t("requiredFieldPointer") }}</small>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="saveDataClick">{{ $t("save") }}</v-btn>
                    <v-btn color="error"   @click="dialog = false">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "EditPriceDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog:      false,
                dataUpdated: false,

                dMin:      0,
                price:     0,
                priceId:   0,
                speciesId: 0
            }
        },

        mounted () {
        },

        watch: {
            /* При показе формы сбрасываем флаг изменения данных */
            dialog: function (val) { if (val) { this.dataUpdated = false; } }
        },

        computed: {
            filteredData () {
                return this.lumber.filter(data => {
                    return Object.keys(this.filters).every(filter => {
                        if (filter == "lengths") {
                            let result = this.filters[filter].length == 0 ? true : false;

                            this.filters[filter].forEach(elm => {
                                let searchFor = elm.trim().indexOf(" ") > 0
                                    ? elm.substring(0, elm.trim().indexOf(" "))
                                    : elm;

                                if (data.lengthsList.indexOf(searchFor) >= 0) { result = true; }
                            });
                            return result;
                        } else {
                            return this.filters[filter].length < 1 || this.filters[filter].includes(data[filter])
                        }
                    })
                });
            },
        },

        methods: {
            /**
             * Сброс значений полей формы
             */
            resetForm () {
                this.dataUpdated = false;
                this.dMin        = 0;
                this.price       = 0;
                this.priceId     = 0;
                this.speciesId   = 0;
            },

            /**
             * Сохранение данных
             */
            saveData () {
                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}prices/`,
                    data: {
                        species_id: Number(this.speciesId),
                        d_min:      Number(this.dMin),
                        price:      Number(this.price)
                    },
                    withCredentials: true
                }).then(() => {
                    //this.$debug.log(response);

                    this.dataUpdated = true;
                }).catch(error => {
                    if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveData") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveData"));
                    }
                });
                this.dialog = false;
            },

            /**
             * Обработчик нажатия на кнопку сохранения
             */
            saveDataClick () {
                if (this.priceId == 0) {
                    this.saveData();
                } else {
                    this.updateData();
                }
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Обновление данных
             */
            updateData () {
                this.axios({
                    method: "patch",
                    url: `${this.$config.apiURL}prices/${this.priceId}/`,
                    data: {
                        species_id: Number(this.speciesId),
                        d_min:      Number(this.dMin),
                        price:      Number(this.price)
                    },
                    withCredentials: true
                }).then(() => {
                    //this.$debug.log(response);

                    this.dataUpdated = true;
                }).catch(error => {
                    if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateData") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateData"));
                    }
                });

                this.dialog = false;
            }
        }
    }
</script>
